var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50836 9.35V13.0917C2.50836 16.8333 4.00836 18.3333 7.75003 18.3333H12.2417C15.9834 18.3333 17.4834 16.8333 17.4834 13.0917V9.35",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 10C11.525 10 12.65 8.75833 12.5 7.23333L11.95 1.66667H8.05832L7.49999 7.23333C7.34999 8.75833 8.47499 10 9.99999 10Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2583 10C16.9416 10 18.175 8.63333 18.0083 6.95833L17.775 4.66667C17.475 2.5 16.6416 1.66667 14.4583 1.66667H11.9166L12.5 7.50833C12.6416 8.88333 13.8833 10 15.2583 10Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70002 10C6.07502 10 7.31669 8.88333 7.45002 7.50833L7.63336 5.66667L8.03336 1.66667H5.49169C3.30836 1.66667 2.47502 2.5 2.17502 4.66667L1.95002 6.95833C1.78336 8.63333 3.01669 10 4.70002 10Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.1667C8.60835 14.1667 7.91669 14.8583 7.91669 16.25V18.3333H12.0834V16.25C12.0834 14.8583 11.3917 14.1667 10 14.1667Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.cc9364d001ca6cb64e57e1c96b19ce2a.svg";
export { ForwardRef as ReactComponent };